export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/wasm-module-2.8de6d9d05f128c49.js");
}
